import { useMemo } from 'react'
import type { Transaction } from '@/lib/hooks'

export type CategoryTxEntry = {
  tx: Transaction
  categoryAmount: number
}

/** Per-transaction entries restricted to a parent category, sorted newest first. */
export function useCategoryTransactions(
  transactions: Transaction[],
  categoryName: string,
): CategoryTxEntry[] {
  return useMemo(() => {
    const list: CategoryTxEntry[] = []
    for (const tx of transactions) {
      let amount = 0
      for (const item of tx.items) {
        if (item.parent_category_name === categoryName) {
          amount += item.amount
        }
      }
      if (amount > 0) {
        list.push({ tx, categoryAmount: amount })
      }
    }
    return list.sort((a, b) => b.tx.date.localeCompare(a.tx.date))
  }, [transactions, categoryName])
}
